import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Scale.css";

function Scale({
  id,
  name,
  description,
  name_english,
  description_english,
  language,
}) {
  const { t } = useTranslation();

  return (
    <Row className="scale align-items-center">
      <Col lg={9} className="scale-header">
        <Col className="scale-header-title">
          <h5>{language === "es" ? name : name_english}</h5>
        </Col>
        <Col className="scale-header-description">
          <h5>{language === "es" ? description : description_english}</h5>
        </Col>
      </Col>
      <Col lg={3} className="scale-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              as={Link}
              to={`/behaviors/competencies/scales/edit/${id}`}
            >
              <FontAwesomeIcon icon={faEdit} />{" "}
              {t("Competencias.Escala.Editar")}
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to={`/behaviors/competencies/scales/delete/${id}`}
            >
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Competencias.Escala.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default Scale;
